document.addEventListener('DOMContentLoaded', function() {
  const pdpThumbnailSlider = {
    selector: '.thumbnail-slider',
    swiperInstance: null,
    init: function() {
      this.slider();
    },
    syncHeightWithGallery: function(callback) {
      // Only apply on desktop (>= 1400px)
      if (window.innerWidth < 1400) {
        if (callback) callback();
        return;
      }
      
      const obj = this;
      const $galleryContainer = $('.product-gallery-slider .swiper-container');
      const $thumbnailSlider = $('.thumbnail-slider');
      const $galleryImages = $('.product-gallery-slider img');
      
      if ($galleryContainer.length && $thumbnailSlider.length) {
        // Wait for gallery images to load
        if ($galleryImages.length > 0) {
          let loadedCount = 0;
          const totalImages = $galleryImages.length;
          
          const checkAndApply = function() {
            loadedCount++;
            if (loadedCount === totalImages) {
              // Small delay to ensure layout is complete
              setTimeout(function() {
                const galleryHeight = $galleryContainer.outerHeight();
                if (galleryHeight > 0) {
                  $thumbnailSlider.css('max-height', galleryHeight + 'px');
                }
                if (callback) callback();
              }, 50);
            }
          };
          
          $galleryImages.each(function() {
            if (this.complete) {
              checkAndApply();
            } else {
              $(this).one('load error', checkAndApply);
            }
          });
        } else {
          const galleryHeight = $galleryContainer.outerHeight();
          if (galleryHeight > 0) {
            $thumbnailSlider.css('max-height', galleryHeight + 'px');
          }
          if (callback) callback();
        }
      } else if (callback) {
        callback();
      }
    },
    updateArrowVisibility: function(swiper, $prevBtn, $nextBtn) {
      // Only apply on desktop (>= 1400px)
      if (window.innerWidth < 1400) return false;
      
      const $thumbnailSlider = $(swiper.el).parent('.thumbnail-slider');
      
      // Show arrows only when not at both beginning AND end
      const needsNavigation = !swiper.isBeginning || !swiper.isEnd;
      
      if (needsNavigation) {
        $prevBtn.show();
        $nextBtn.show();
        $thumbnailSlider.removeClass('no-arrows');
      } else {
        $prevBtn.hide();
        $nextBtn.hide();
        $thumbnailSlider.addClass('no-arrows');
      }
      
      return needsNavigation;
    },
    slider: function () {
      let obj = this;
      if($(`${this.selector}`).length > 0){
        $(`${this.selector}`).each(function(){

          if($(this).find('.swiper-container').hasClass('swiper-container-initialized')) return;

          const $container = $(this);
          const $prevBtn = $container.find('.swiper-button-prev');
          const $nextBtn = $container.find('.swiper-button-next');

          let swiper = new Swiper($container.find('.swiper-container')[0], {
            loop: false,
            direction: 'horizontal',
            slidesPerView: 'auto',
            spaceBetween: 12,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            keyboard: {
              enabled: true,
              onlyInViewport: true,
            },
            breakpoints: {
              1400: {
                direction: 'vertical',
                slidesPerView: 'auto',
                navigation: {
                  nextEl: $(this).find('.swiper-button-next')[0],
                  prevEl: $(this).find('.swiper-button-prev')[0],
                },
              }
            },
            on: {
              init: function() {
                // Add initialized class to thumbnail-slider container
                $(this.el).closest(obj.selector).addClass('thumbnail-slider-initialized');
              }
            }
          });
          
          // Check arrows after images load
          const $images = $container.find('img');
          if ($images.length > 0) {
            let loadedCount = 0;
            const totalImages = $images.length;
            
            $images.each(function() {
              if (this.complete) {
                loadedCount++;
                if (loadedCount === totalImages) {
                  swiper.update();
                  
                  // Sync thumbnail height with gallery first, then update arrows
                  obj.syncHeightWithGallery(function() {
                    swiper.update();
                    const showArrows = obj.updateArrowVisibility(swiper, $prevBtn, $nextBtn);
                    
                    if (showArrows && window.innerWidth >= 1400) {
                      swiper.update();
                    }
                  });
                }
              } else {
                $(this).one('load error', function() {
                  loadedCount++;
                  if (loadedCount === totalImages) {
                    swiper.update();
                    
                    // Sync thumbnail height with gallery first, then update arrows
                    obj.syncHeightWithGallery(function() {
                      swiper.update();
                      const showArrows = obj.updateArrowVisibility(swiper, $prevBtn, $nextBtn);
                      
                      // Update swiper with offset if arrows are shown
                      if (showArrows && window.innerWidth >= 1400) {
                        swiper.update();
                      }
                    });
                  }
                });
              }
            });
          } else {
            swiper.update();
            
            // Sync thumbnail height with gallery first, then update arrows
            obj.syncHeightWithGallery(function() {
              swiper.update();
              const showArrows = obj.updateArrowVisibility(swiper, $prevBtn, $nextBtn);
              
              // Update swiper with offset if arrows are shown
              if (showArrows && window.innerWidth >= 1400) {
                swiper.params.slidesOffsetBefore = 30;
                swiper.params.slidesOffsetAfter = 20;
                swiper.update();
              }
            });
          }
          
          obj.swiperInstance = swiper;
        });
      }
    },
    getSlider: function(){
      return this.swiperInstance;
    },
    handleResize: function() {
      const obj = this;
      const swiper = this.swiperInstance;
      if (!swiper) return;
      
      const $container = $(this.selector);
      const $prevBtn = $container.find('.swiper-button-prev');
      const $nextBtn = $container.find('.swiper-button-next');
      const $thumbnailSlider = $('.thumbnail-slider');
      
      // Reset height on mobile
      if (window.innerWidth < 1400) {
        $thumbnailSlider.css('max-height', '');
        $prevBtn.hide();
        $nextBtn.hide();
      }
      
      // Sync height and update swiper
      this.syncHeightWithGallery(function() {
        swiper.update();
        obj.updateArrowVisibility(swiper, $prevBtn, $nextBtn);
      });
    }
  };

  const productGallerySlider = {
    selector: '.product-gallery-slider',
    swiperInstance: null,
    thumbnailSlider: null,
    init: function(thumbnailSlider) {
      this.thumbnailSlider = thumbnailSlider;
      this.slider();
    },
    slider: function () {
      let obj = this;
      if($(`${this.selector}`).length > 0){
        $(`${this.selector}`).each(function(){

          if($(this).find('.swiper-container').hasClass('swiper-container-initialized')) return;
          
          // Don't initialize Swiper if there's only one slide
          const $slides = $(this).find('.swiper-slide');
          if ($slides.length <= 1) return;

          let swiper = new Swiper($(this).find('.swiper-container')[0], {
            loop: false,
            slidesPerView: 'auto',
            centeredSlidesBounds: true,
            spaceBetween: 0,
            allowTouchMove: true,
            setWrapperSize: false,
            keyboard: {
              enabled: true,
              onlyInViewport: true,
            },
            navigation: {
              nextEl: $(this).find('.swiper-button-next')[0],
              prevEl: $(this).find('.swiper-button-prev')[0],
            },
            thumbs: {
              swiper: obj.thumbnailSlider
            },
          });
        });
      }
    },
    getSlider: function(){
      return this.swiperInstance;
    }
  };

  // Initialize thumbnail first
  pdpThumbnailSlider.init();

  // Then initialize main slider with thumbnail reference
  productGallerySlider.init(pdpThumbnailSlider.getSlider());
  
  // Handle resize for thumbnail slider updates
  let resizeTimer;
  $(window).on('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      pdpThumbnailSlider.handleResize();
    }, 250); // Debounce to prevent continuous calculations during resize
  });
});